export default function Navbar() {
    return (
        <div className="bg-slate-300 h-10 flex justify-center px-4">
            <div className="container flex">
                <h1 className="self-center text-xl">PerfScript</h1>
            </div>
        </div>
    );
}